import React from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';
import moment from 'moment';
import cx from 'classnames';

import { AssignmentInfoTypes } from 'features/assignment/enums';
import { summaryAssignmentsEndingSoonDataSelector } from 'redux/selectors/homeDashboardSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './AssignmentsEndingSoonCard.module.less';
import { isNil } from 'lodash';

export default function AssignmentsEndingSoonCard() {
  const summaryAssignmentsEndingSoonData = useAppSelector(
    summaryAssignmentsEndingSoonDataSelector,
  );
  const assignmentTotalCount =
    summaryAssignmentsEndingSoonData?.assignmentTotalCount || 0;
  const data = summaryAssignmentsEndingSoonData?.details || [];

  return (
    <div className={styles.wrapper}>
      <Row gutter={[10, 10]}>
        <Col xs={16}>
          <div className={styles.title}>
            <Link to="/assignments-ending-soon-details">
              Assignments Ending Soon
            </Link>
          </div>
        </Col>

        <Col xs={8}>
          <div className={cx(styles.title, styles.textRight)}>
            {pluralize('assignment', assignmentTotalCount, true)}
          </div>
        </Col>

        <Col xs={24}>
          {!data.length && (
            <span>
              You currently do not have any assignments that are ending soon.
            </span>
          )}
          {!!data.length && (
            <div className={styles.tableBox}>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Assignment Key</th>
                    <th>Worker Name</th>
                    <th>End Date</th>
                    <th>Last Working Day</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((entry, index) => (
                    <tr key={entry.assignmentId}>
                      <td>{index + 1}</td>
                      <td>
                        <Link
                          to={`/assignment/${entry.assignmentKey}?section=${AssignmentInfoTypes.Primary}`}
                        >
                          {entry.assignmentKey}
                        </Link>
                      </td>
                      <td>
                        <span>{entry.workerName}</span>
                      </td>
                      <td>
                        <span className="icon icon-calendar" />
                        <span>
                          {moment.utc(entry.jobEndDate).format('MM/DD/YYYY')}
                        </span>
                      </td>
                      <td>
                        {!isNil(entry.terminationDate) && (
                          <>
                            <span className="icon icon-calendar" />
                            <span>
                              {moment
                                .utc(entry.terminationDate)
                                .format('MM/DD/YYYY')}
                            </span>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
